import React, { useEffect, useState } from 'react';
import { Swiper, SwiperSlide } from 'swiper/react';
import 'swiper/css';
import 'swiper/css/pagination';
import 'swiper/css/navigation';
import { Pagination, Navigation } from 'swiper/modules';
import { rightArrow, rightArrowHover, subMenuContact4, subMenuHome, subMenuPartners, subMenuProjects } from '../../../assets/images';
import { useTranslation } from 'react-i18next';
import './News.css'
import AOS from 'aos';
import 'aos/dist/aos.css';

const News = () => {
  const { t } = useTranslation();

  useEffect(() => {
    AOS.init({ duration: 2000, once: false }); 
  }, []);

  const newsItems = [
    {
      id: 1,
      imgSrc: subMenuHome,
      title: 'HITACHI-nin yapon nümayəndələri  A-kond MMC-ni ziyarət etdi',
      date: '15.04.2025',
    },
    {
      id: 2,
      imgSrc: subMenuPartners,
      title: 'HITACHI-nin yapon nümayəndələri  A-kond MMC-ni ziyarət etdi',
      date: '12.04.2025',
    },
    {
      id: 3,
      imgSrc: subMenuProjects,
      title: 'HITACHI-nin yapon nümayəndələri  A-kond MMC-ni ziyarət etdi',
      date: '10.04.2025',
    },
    {
        id: 4,
        imgSrc: subMenuHome,
        title: 'HITACHI-nin yapon nümayəndələri  A-kond MMC-ni ziyarət etdi',
        date: '15.04.2025',
      },
      {
        id: 5,
        imgSrc: subMenuPartners,
        title: 'HITACHI-nin yapon nümayəndələri  A-kond MMC-ni ziyarət etdi',
        date: '12.04.2025',
      },
      {
        id: 6,
        imgSrc: subMenuProjects,
        title: 'HITACHI-nin yapon nümayəndələri  A-kond MMC-ni ziyarət etdi',
        date: '10.04.2025',
      },
      {
        id: 7,
        imgSrc: subMenuHome,
        title: 'HITACHI-nin yapon nümayəndələri  A-kond MMC-ni ziyarət etdi',
        date: '15.04.2025',
      },
      {
        id: 8,
        imgSrc: subMenuPartners,
        title: 'HITACHI-nin yapon nümayəndələri  A-kond MMC-ni ziyarət etdi',
        date: '12.04.2025',
      },
      {
        id: 9,
        imgSrc: subMenuProjects,
        title: 'HITACHI-nin yapon nümayəndələri  A-kond MMC-ni ziyarət etdi',
        date: '10.04.2025',
      },
  ];

  return (
    <div data-aos="fade-up" className='mt-[90px] md:mt-[118px]'>
      <div className='w-full justify-center items-center relative flex'>
      <div className='md:max-w-container max-w-containerSm flex flex-col mx-auto justify-between relative'>
        {/* Başlık */}
        <div className='flex justify-between items-center h-[50px]'>
          <div className='flex items-center'>
            <p className='text-[24px] md:text-[32px] font-medium text-[#008A7F]'>{t("Önəçıxan xəbərlər")}</p>
          </div>
          <div className="absolute top-0 right-0 flex gap-2">
            <button className="swiper-button-prev-custom border-2 border-[#E5E5E5] group hover:border-[#01A396] p-[10px] rounded-lg">
              <i className="fa-solid fa-angle-left w-4 text-[#767676] group-hover:text-[#01A396]"></i>
            </button>
            <button className="swiper-button-next-custom border-2 border-[#E5E5E5] group hover:border-[#01A396] p-[10px] rounded-lg">
              <i className="fa-solid fa-angle-right w-4 text-[#767676] group-hover:text-[#01A396]"></i>
            </button>
          </div>
        </div>

        {/* Slider */}
        <div className='mt-10'>
          <Swiper
            spaceBetween={30}
            loop={true}
            pagination={{ clickable: true }}
            navigation={{
              nextEl: '.swiper-button-next-custom',
              prevEl: '.swiper-button-prev-custom',
            }}
            modules={[Pagination, Navigation]}
            breakpoints={{
              480: { slidesPerView: 1 },
              640: { slidesPerView: 2 },
              768: { slidesPerView: 3 },
              1024: { slidesPerView: 4 },
            }}
          >
            {newsItems.map((item) => (
              <SwiperSlide key={item.id}>
              <a key={item.id} href={`/news/${item.id}`}>
  <div className="group overflow-hidden rounded-lg">
    <div className="relative">
      <img 
        src={item.imgSrc}
        className="w-full transition-transform duration-300 group-hover:scale-105"
        alt=""
      />
      <span className="absolute top-3 right-3 text-[#008A7F] bg-[#F6FAFA] text-[12px] h-[21px] w-[83px] rounded-[12px] text-center flex items-center justify-center">
        {item.date}
      </span>
    </div>
    <p className="mt-3 text-[#1C1C1C]">{item.title}</p>
  </div>
</a>

              </SwiperSlide>
            ))}
          </Swiper>
        </div>
        <div className='mt-10 flex justify-center md:justify-end'>
        <a href='/news' className="group">
  <div className='flex items-center justify-between w-[158px] rounded-[12px] bg-[#FBFBFB] text-[#1C1C1C] h-[46px] px-3'>
    <p className="transition-colors duration-300 group-hover:text-[#008A7F]">Hamısına bax</p>
    <img
      className='w-2 transition-opacity duration-300 group-hover:hidden'
      src={rightArrow}
      alt=""
    />
    <img
      className='w-2 transition-opacity duration-300 hidden group-hover:block'
      src={rightArrowHover}
      alt=""
    />
  </div>
</a>

        </div>
      </div>
    </div>
    </div> 
  );
};

export default News;  
     